import { Utils } from "../utilities/Utils";
import { FormTagsPlugin } from 'bootstrap-vue';

export interface IBooking {
    id: number;
    guid: string;
    contractorID: number;
    contractorAdminID: number;
    worksPostCode: string;
    worksLatitude: number;
    worksLongitude: number;
    worksWhatThreeWords: string;
    worksPlaceName: string;
    description: string;
    firstStay: Date;
    lastStay: Date;
    isDayStay: boolean;
    totalDays: number;
    latestArrivalDefault: Date;
    foodAllowance: number;
    parkingRequirements: string;
    additionalComments: string;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
    statusID: number;
    statusDescription: string;
    totalNights: number;
    isBookingOnly: boolean;
    costCodeID: number;
    contractorHotelNotes: string;

}

export class Booking implements IBooking {

    constructor(data?: IBooking) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBooking) {
        Utils.clone(data, this);
    }

    id: number = 0;
    guid: string = Utils.emptyGuidValue;
    contractorID: number = 0;
    contractorAdminID: number = 0;
    worksPostCode: string = "";
    worksLatitude: number = 0;
    worksLongitude: number = 0;
    worksWhatThreeWords: string = "";
    worksPlaceName: string = "";
    description: string = "";
    firstStay: Date = new Date(Utils.emptyDateValue);
    lastStay: Date = new Date(Utils.emptyDateValue);
    isDayStay: boolean = false;
    totalDays: number = 0;
    latestArrivalDefault: Date = new Date();
    foodAllowance: number = 0;
    parkingRequirements: string = "";
    additionalComments: string = "";
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;
    statusID: number = 0;
    statusDescription: string = "";
    totalNights: number = 0;
    isBookingOnly: boolean = false;
    costCodeID: number = 0;
    contractorHotelNotes: string = "";

    get isNew() {
        return Utils.isEmptyId(this.id);
    }

    get latestArrivalDefaultTime() {
        if (this.latestArrivalDefault == null) { this.latestArrivalDefault = new Date(); }
        return this.latestArrivalDefault.getHours() + ':' + this.latestArrivalDefault.getMinutes() + ':' + this.latestArrivalDefault.getSeconds();
    }

    set latestArrivalDefaultTime(val: string) {

        const parts = val.split(":");

        this.latestArrivalDefault.setHours(+parts[0]);
        this.latestArrivalDefault.setMinutes(+parts[1]);
        this.latestArrivalDefault.setSeconds(+parts[2]);
    }


}